import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ChangeStatusShopDialogConfirm from './ChangeStatusShopDialogConfirm';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    menuEventId,
    setMenuEventId,
    disableStatus,
    message,
    setMessage,
    params
  }) => {
    const changeActionConfirm = () => {
      updateOpenChangeConfirm(true);
      if (menuEventId) {
        setMessage('更新してもよろしいでしょうか？');
      }
    };
    const cancelActionConfirm = () => {
      updateOpenChangeConfirm(false);
    };
    const updateMenuEventId = value => {
      setMenuEventId(value);
    };
    return (
      <Dialog
        open={openChange}
        onClose={() => {
          updateOpenChange(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography component="p" className={classes.description}>
            イベントメニューを選択してください。
          </Typography>
          {params.menuEvents && params.menuEvents.length > 0 ? (
            <RadioGroup
              value={String(menuEventId || params.menuEventId)}
              onChange={e => {
                updateMenuEventId(e.target.value);
              }}
            >
              {params.menuEvents.map(menuEvent => {
                return (
                  <div>
                    <FormControlLabel
                      value={String(menuEvent.menuEventId)}
                      control={
                        <Radio color="primary" disabled={disableStatus} />
                      }
                      label={menuEvent.menuName}
                    />
                  </div>
                );
              })}
            </RadioGroup>
          ) : (
            <div>イベントメニューがありません。</div>
          )}
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ChangeButton
            onClickAction={changeActionConfirm}
            enabled={!(!menuEventId && !params.menuEventId)}
          />
        </DialogActions>
        <ChangeStatusShopDialogConfirm
          message={message}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          cancelAction={cancelActionConfirm}
          changeAction={changeAction}
        />
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
